import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const AddExperienceAchivement = ({
  getUserCv,
  userDataId,
  handleCloseExperienceAchivement,
  showExperienceAchivement,
  experienceData,
}) => {
  console.log("experienceAchivementData", experienceData);
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [achivement, setAchivement] = useState("");
  const [achivementDate, setAchivementDate] = useState("");
  const [display, setDisplay] = useState(false);



// ..............................................................
 const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFieldChange = (setter, value, fieldName) => {
    setter(value);
  
    // Ensure values are strings (avoid trim() errors)
    const updatedAchievement = fieldName === "achivement" ? String(value || "") : String(achivement || "");
    const updatedAchievementDate = fieldName === "achivementDate" ? String(value || "") : String(achivementDate || "");
  
    // Check if all required fields are filled
    const allFieldsFilled = updatedAchievement.trim() !== "" && updatedAchievementDate.trim() !== "";
  
    setFormChanged(allFieldsFilled);
  };
  // .............................................................
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    setIsSubmitting(true); // Disable the button during submission
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      expId: experienceData.usrDataExpId,
      // expAchvmntId: experienceAchivementData,
      achievement: achivement,
      achivementDate: moment(achivementDate).format("YYYY-MM-DD"),
    };
    console.log("body====>", body);
    if (achivement === '' || achivementDate === '') {
      toast.error('Please fill all the required fields');
      setIsSubmitting(false); // Re-enable the button if validation fails
    } else {
      try {
        const res = await axios.post("/Resume/AddExperienceAchievement", body);
        toast.success(res.data.message);
        resetForm();
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      } finally {
        setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
      }
    }
  };

  // .................................. Enable and Disabled
  const resetForm = () => {
    handleCloseExperienceAchivement();
    getUserCv();
    setAchivement("");
    setAchivementDate('')
    setDisplay(false)
    setFormChanged(false); // Disable the button after update
  }

  const handleCloseExperienceAchivementFn = () => {
    resetForm(); // Call resetForm when closing the modal
    handleCloseExperienceAchivement();
  };
  return (
    <Modal
      show={showExperienceAchivement}
      onHide={handleCloseExperienceAchivementFn}
      centered
      size="lg"
    >

      <Modal.Header>
        <Modal.Title>Add experience achievement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseExperienceAchivementFn}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Achievement <span style={{ color: "red" }}> *</span></Form.Label>
              <Form.Control
                type="text"
                className="Dark-Input-from-group"
                value={achivement}
                // onChange={(e) => setAchivement(e.target.value)}
                // onChange={(e) => handleFieldChange(setAchivement, e.target.value)} // Track changes
                onChange={(e) => handleFieldChange(setAchivement, e.target.value, "achivement")} // Track changes
                placeholder="Enter achievement"
              />
              {display && !achivement ? (
                <span className="error_msg_lbl">Add achievement </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear" className="Flatpickr-Calender-Class">
              <Form.Label className="class-type col-md-12">Achievement date <span style={{ color: "red" }}> *</span></Form.Label>
              <Flatpickr
                type="number"
                value={achivementDate}
                // onChange={(date) => setAchivementDate(date[0])}
                // onChange={(date) => handleFieldChange(setAchivementDate, (date[0]))} // Track changes
                onChange={(date) => handleFieldChange(setAchivementDate, date[0], "achivementDate")} // Track changes
                placeholder="Enter achivement date"
              // disabled={isPresent}
              options={{
                maxDate: new Date(),
                static: true, // Keeps the calendar visible on click         
              }} 
              />
              {display && !achivementDate ? (
                <span className="error_msg_lbl">Select achievement date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
             onClick={handleSubmit}
             style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                // onClick={handleSubmit}
                // onClick={handleSubmit}
                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}  >
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddExperienceAchivement;
